const Contact = () =>{
    return(
        <div className="contact">
            <h1>Contact Us</h1>
            <h2>Address</h2>
            <p>3481 Melrose Place, Brooklyn, NY 11201, USA.</p>
            <p>+1-9347983698</p>
        </div>
    )
};

export default Contact;
